<div fxFlex fxLayout="column" fxFlexFill>
    <div fxFlex>
        <mat-toolbar color="primary">
            <mat-toolbar-row>
                <div fxShow="true" fxHide.lt-md fxFlex fxLayout>
                    <div fxFlex>
                        <span class="mat-h3">{{ "PROFILE.UPDATE.title" | translate }}</span>
                    </div>
                </div>
            </mat-toolbar-row>
        </mat-toolbar>
    </div>
    <div fxFlex class="p-10">
        <div class="content p-20" fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="20px" fxFlexFill fxLayoutAlign.gt-xs="space-around center">
            <form #profileForm="ngForm" (ngSubmit)="onProfileFormSubmit()" fxFlex="100" fxFlex.gt-sm="50" [formGroup]="profileFormGroup">
                <mat-card appearance="outlined" style="padding: 10px">
                    <mat-card-title>
                        {{ "PROFILE.UPDATE.title" | translate }}
                    </mat-card-title>
                    <mat-card-content>
                        <div class="p-10">
                            <div fxLayout="column" fxLayout.gt-lg="row" fxLayoutGap="20px" fxFlexFill>
                                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                    <mat-label>{{ "PROFILE.UPDATE.firstName" | translate }}</mat-label>
                                    <input matInput [placeholder]="'PROFILE.UPDATE.firstName' | translate" name="firstName" formControlName="firstName" />
                                    @if (profileFormGroup.controls["firstName"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                    <mat-label>{{ "PROFILE.UPDATE.lastName" | translate }}</mat-label>
                                    <input matInput [placeholder]="'PROFILE.UPDATE.lastName' | translate" name="lastName" formControlName="lastName" />
                                    @if (profileFormGroup.controls["lastName"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions style="text-align: right; display: block">
                        <button mat-raised-button color="primary" class="btn-block" type="submit">{{ "PROFILE.UPDATE.submit" | translate }}</button>
                    </mat-card-actions>
                </mat-card>
            </form>
            <form #passwordForm="ngForm" (ngSubmit)="onPasswordFormSubmit()" fxFlex="100" fxFlex.gt-sm="50" [formGroup]="passwordFormGroup">
                <mat-card appearance="outlined" style="padding: 10px">
                    <mat-card-title> Password </mat-card-title>
                    <mat-card-content>
                        <div class="p-10">
                            <div fxLayout="row" fxLayoutGap="10px">
                                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                    <mat-label>{{ "PROFILE.UPDATE.password" | translate }}</mat-label>
                                    <input matInput [placeholder]="'PROFILE.UPDATE.password' | translate" name="password" formControlName="password" type="password" />
                                    @if (passwordFormGroup.controls["password"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                    <mat-label>{{ "PROFILE.UPDATE.newPassword" | translate }}</mat-label>
                                    <input matInput [placeholder]="'PROFILE.UPDATE.newPassword' | translate" name="password" formControlName="newPassword" type="password" />
                                    @if (passwordFormGroup.controls["newPassword"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                                    <mat-label>{{ "PROFILE.UPDATE.repeatPassword" | translate }}</mat-label>
                                    <input
                                        matInput
                                        [placeholder]="'PROFILE.UPDATE.repeatPassword' | translate"
                                        name="repeatPassword"
                                        formControlName="repeatPassword"
                                        type="password"
                                    />
                                    @if (passwordFormGroup.controls["repeatPassword"].hasError("required")) {
                                        <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                                    }
                                    @if (passwordFormGroup.hasError("notSame")) {
                                        <mat-error> {{ "PROFILE.UPDATE.passwordNotMatchError" | translate }}</mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions style="text-align: right; display: block">
                        <button mat-raised-button color="primary" class="btn-block" type="submit">{{ "PROFILE.UPDATE.submit" | translate }}</button>
                    </mat-card-actions>
                </mat-card>
            </form>
        </div>
    </div>
</div>
